export function ArrowDoubleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.412 10.002l-5.41 5.41a1 1 0 00.63 1.704l5.862.451a1 1 0 001.073-1.073l-.45-5.862a1 1 0 00-1.705-.63zm-6.824 3.996l5.41-5.41a1 1 0 00-.63-1.704l-5.862-.451a1 1 0 00-1.073 1.073l.45 5.862a1 1 0 001.705.63z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
